const chipClasses = {
  root: 'zds-chip-root',
  icon: 'zds-chip-icon',
  avatar: 'zds-chip-avatar',
  label: 'zds-chip-label',
  trailing: 'zds-chip-trailing',
} as const;

export { chipClasses };
